import { GridBtnsOptions } from './grid-btns-options.enum';

/**
 * Represents an event (click, callback) in any of the buttons. Contains a payload.
 */
export class GridBtnsEvent {
  constructor(public btn: GridBtnsOptions, public data?: any) {}
}
